// extracted by mini-css-extract-plugin
module.exports = {"ourProcess":"OurProcess_ourProcess__1Jdd7"};